<template>
    <div>
        <div class="block-content">
            <div class="col-sm-12 table-responsive">
                <table class="table table-striped table-vcenter">
                    <thead>
                        <tr role="row">
                            <th class="text-center" tabindex="0">
                                #
                            </th>
                            <th class="text-capitalize">
                                Email
                            </th>
                            <th class="text-capitalize">
                                Fullname
                            </th>
                            <th class="text-capitalize">
                                Amount
                            </th>
                            <th class="text-capitalize">
                                Loan Type
                            </th>
                            <th class="text-capitalize">
                                Status
                            </th>
                      
                            <th class="text-capitalize">
                                Expiry
                            </th>

                            <th class="text-center text-capitalize">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            role="row"
                            class="odd"
                            v-for="(loan, index) in loans"
                        >
                            <td class="text-center sorting_1">
                                {{ index + 1 }}
                            </td>
                            <td>
                                {{ loan.email }}
                            </td>
                            <td>
                                {{ loan.name }}
                            </td>
                            <td>
                               {{ loan.log.currency.symbol }}{{ loan.amount }}
                            </td>
                            <td>
                                {{ loan.description }}
                            </td>
                            <td>
                                <span
                                    class="text-warning"
                                    v-if="loan.status == 0"
                                    >Pending</span
                                >
                                <span class="text-success" v-else>Approved</span>
                            </td>
                          

                            <td>
                                {{ new Date(loan.expiry).toDateString() }}
                            </td>


                            <td>
                                <div class="btn-group">
                                    <button
                                        v-if="loan.status == 1"
                                        type="button"
                                        class="btn btn-sm btn-danger mr-2"
                                        data-toggle="tooltip"
                                        title="Edit"
                                        @click.prevent="updateStatus(loan.id)"
                                    >
                                        UnApprove
                                    </button>
                                    <button
                                        v-else
                                        type="button"
                                        class="btn btn-sm btn-success mr-2"
                                        data-toggle="tooltip"
                                        title="Edit"
                                        @click.prevent="updateStatus(loan.id)"
                                    >
                                        Approve
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-danger"
                                        data-toggle="tooltip"
                                        title="Delete"
                                        @click.prevent="deleteLoan(loan.id)"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { RepositoryFactory } from "../../repository/RepositoryFactory";
const UsersRepository = RepositoryFactory.get("users");
export default {
    data() {
        return {
            loans: []
        };
    },
    methods: {
        async updateStatus(id) {
            try {
                await UsersRepository.adminUpdateLoanStatus(id);
                await this.fetchLoans();
                toast.fire({
                    type: "success",
                    title: "Loan status updated successfully"
                });
            } catch (error) {
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        },
        async deleteLoan(id) {
            try {
                await UsersRepository.adminDeleteLoan(id);
                toast.fire({
                    type: "success",
                    title: "Loan deleted successfully"
                });
            } catch (error) {
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        },
        async fetchLoans() {
            try {
                let res = await UsersRepository.adminFetchLoans();
                this.loans = res.data;
            } catch (error) {
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
            }
        }
    },
    created() {
        this.fetchLoans();
    }
};
</script>
